import moment from "moment-hijri";
import { CalendarPlus, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLang } from "@/lib/i18n";

export const AddToCalendar = ({ event, slug }) => {
  const { t } = useLang();
  const fmt = (iso) => moment(iso).format("YYYYMMDDTHHmmss");
  const end = event.end || event.start;
  const location = event.location || event.mosque_name || "";

  const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&dates=${fmt(event.start)}/${fmt(end)}&details=${encodeURIComponent(event.description || "")}&location=${encodeURIComponent(location)}`;
  const outlookUrl = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(event.title)}&startdt=${event.start}&enddt=${end}&body=${encodeURIComponent(event.description || "")}&location=${encodeURIComponent(location)}`;
  const icsUrl = `${process.env.REACT_APP_BACKEND_URL}/api/associations/${slug}/events/${event.id}/ics`;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid="add-to-calendar-btn" className="rounded-full">
          <CalendarPlus className="h-4 w-4 mr-2" /> {t("add_to_calendar")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem data-testid="add-google-calendar" onClick={() => window.open(googleUrl, "_blank")}>
          {t("google_calendar")}
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="add-apple-calendar" onClick={() => window.open(icsUrl, "_blank")}>
          {t("apple_calendar")}
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="add-outlook-calendar" onClick={() => window.open(outlookUrl, "_blank")}>
          {t("outlook")}
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="download-ics" onClick={() => window.open(icsUrl, "_blank")}>
          <Download className="h-4 w-4 mr-2" /> {t("download_ics")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
